import autoAnimate from '@formkit/auto-animate'
import "bluesky-comments-tag/load";

const comments = document.getElementById('comments');
const trigger = document.getElementById('dropdown-trigger');
const bskyComments = document.getElementById('bsky-comments');
bskyComments.remove();
autoAnimate(comments);
trigger.addEventListener('click', () => {
  if (comments.contains(bskyComments)) {
    bskyComments.remove();
    trigger.innerText = "Show comments";
  } else {
    comments.appendChild(bskyComments)
    trigger.innerText = "Hide comments";
  }
});
